export default {

    computed: {
        counties() {
            return [
                { name: 'Non UK', value: 'Non UK' },
                {
                    name: 'England',
                    options: [
                        { name: 'Bath and North East Somerset', value: 'Bath and North East Somerset' },
                        { name: 'Bedford', value: 'Bedford' },
                        { name: 'Berkshire', value: 'Berkshire' },
                        { name: 'Blackburn with Darwen', value: 'Blackburn with Darwen' },
                        { name: 'Blackpool', value: 'Blackpool' },
                        { name: 'Bournemouth', value: 'Bournemouth' },
                        { name: 'Brighton & Hove', value: 'Brighton & Hove' },
                        { name: 'Bristol', value: 'Bristol' },
                        { name: 'Buckinghamshire', value: 'Buckinghamshire' },
                        { name: 'Cambridgeshire', value: 'Cambridgeshire' },
                        { name: 'Central Bedfordshire', value: 'Central Bedfordshire' },
                        { name: 'Cheshire East', value: 'Cheshire East' },
                        { name: 'Cheshire West and Chester', value: 'Cheshire West and Chester' },
                        { name: 'Cornwall', value: 'Cornwall' },
                        { name: 'Cumbria', value: 'Cumbria' },
                        { name: 'Darlington', value: 'Darlington' },
                        { name: 'Derby', value: 'Derby' },
                        { name: 'Derbyshire', value: 'Derbyshire' },
                        { name: 'Devon', value: 'Devon' },
                        { name: 'Dorset', value: 'Dorset' },
                        { name: 'Durham', value: 'Durham' },
                        { name: 'East Riding of Yorkshire', value: 'East Riding of Yorkshire' },
                        { name: 'East Sussex', value: 'East Sussex' },
                        { name: 'Essex', value: 'Essex' },
                        { name: 'Gloucestershire', value: 'Gloucestershire' },
                        { name: 'Greater London', value: 'Greater London' },
                        { name: 'Greater Manchester', value: 'Greater Manchester' },
                        { name: 'Halton', value: 'Halton' },
                        { name: 'Hampshire', value: 'Hampshire' },
                        { name: 'Hartlepool', value: 'Hartlepool' },
                        { name: 'Herefordshire', value: 'Herefordshire' },
                        { name: 'Hertfordshire', value: 'Hertfordshire' },
                        { name: 'Isle of Wight', value: 'Isle of Wight' },
                        { name: 'Kent', value: 'Kent' },
                        { name: 'Kingston upon Hull', value: 'Kingston upon Hull' },
                        { name: 'Lancashire', value: 'Lancashire' },
                        { name: 'Leicester', value: 'Leicester' },
                        { name: 'Leicestershire', value: 'Leicestershire' },
                        { name: 'Lincolnshire', value: 'Lincolnshire' },
                        { name: 'Luton', value: 'Luton' },
                        { name: 'Medway', value: 'Medway' },
                        { name: 'Merseyside', value: 'Merseyside' },
                        { name: 'Middlesbrough', value: 'Middlesbrough' },
                        { name: 'Milton Keynes', value: 'Milton Keynes' },
                        { name: 'Norfolk', value: 'Norfolk' },
                        { name: 'North East Lincolnshire', value: 'North East Lincolnshire' },
                        { name: 'North Lincolnshire', value: 'North Lincolnshire' },
                        { name: 'North Somerset', value: 'North Somerset' },
                        { name: 'North Yorkshire', value: 'North Yorkshire' },
                        { name: 'Northamptonshire', value: 'Northamptonshire' },
                        { name: 'Northumberland', value: 'Northumberland' },
                        { name: 'Nottingham', value: 'Nottingham' },
                        { name: 'Nottinghamshire', value: 'Nottinghamshire' },
                        { name: 'Oxfordshire', value: 'Oxfordshire' },
                        { name: 'Peterborough', value: 'Peterborough' },
                        { name: 'Plymouth', value: 'Plymouth' },
                        { name: 'Poole', value: 'Poole' },
                        { name: 'Portsmouth', value: 'Portsmouth' },
                        { name: 'Redcar and Cleveland', value: 'Redcar and Cleveland' },
                        { name: 'Rutland', value: 'Rutland' },
                        { name: 'Shropshire', value: 'Shropshire' },
                        { name: 'Somerset', value: 'Somerset' },
                        { name: 'South Gloucestershire', value: 'South Gloucestershire' },
                        { name: 'South Yorkshire', value: 'South Yorkshire' },
                        { name: 'Southampton', value: 'Southampton' },
                        { name: 'Southend-on-Sea', value: 'Southend-on-Sea' },
                        { name: 'Staffordshire', value: 'Staffordshire' },
                        { name: 'Stockton-on-Tees', value: 'Stockton-on-Tees' },
                        { name: 'Stoke-on-Trent', value: 'Stoke-on-Trent' },
                        { name: 'Suffolk', value: 'Suffolk' },
                        { name: 'Surrey', value: 'Surrey' },
                        { name: 'Swindon', value: 'Swindon' },
                        { name: 'Telford and Wrekin', value: 'Telford and Wrekin' },
                        { name: 'Thurrock', value: 'Thurrock' },
                        { name: 'Torbay', value: 'Torbay' },
                        { name: 'Tyne and Wear', value: 'Tyne and Wear' },
                        { name: 'Warrington', value: 'Warrington' },
                        { name: 'Warwickshire', value: 'Warwickshire' },
                        { name: 'West Midlands', value: 'West Midlands' },
                        { name: 'West Sussex', value: 'West Sussex' },
                        { name: 'West Yorkshire', value: 'West Yorkshire' },
                        { name: 'Wiltshire', value: 'Wiltshire' },
                        { name: 'Worcestershire', value: 'Worcestershire' },
                        { name: 'York', value: 'York' },
                    ]
                },
                {
                    name: 'Scotland',
                    options: [
                        { name: 'Aberdeen', value: 'Aberdeen' },
                        { name: 'Aberdeenshire', value: 'Aberdeenshire' },
                        { name: 'Angus', value: 'Angus' },
                        { name: 'Argyll and Bute', value: 'Argyll and Bute' },
                        { name: 'Ayrshire and Arran', value: 'Ayrshire and Arran' },
                        { name: 'Banffshire', value: 'Banffshire' },
                        { name: 'Berwickshire', value: 'Berwickshire' },
                        { name: 'Caithness', value: 'Caithness' },
                        { name: 'Clackmannanshire', value: 'Clackmannanshire' },
                        { name: 'Dumfries', value: 'Dumfries' },
                        { name: 'Dunbartonshire', value: 'Dunbartonshire' },
                        { name: 'Dundee', value: 'Dundee' },
                        { name: 'East Lothian', value: 'East Lothian' },
                        { name: 'Edinburgh', value: 'Edinburgh' },
                        { name: 'Fife', value: 'Fife' },
                        { name: 'Glasgow', value: 'Glasgow' },
                        { name: 'Inverness', value: 'Inverness' },
                        { name: 'Kincardineshire', value: 'Kincardineshire' },
                        { name: 'Lanarkshire', value: 'Lanarkshire' },
                        { name: 'Midlothian', value: 'Midlothian' },
                        { name: 'Moray', value: 'Moray' },
                        { name: 'Nairn', value: 'Nairn' },
                        { name: 'Orkney Islands', value: 'Orkney Islands' },
                        { name: 'Perth and Kinross', value: 'Perth and Kinross' },
                        { name: 'Renfrewshire', value: 'Renfrewshire' },
                        { name: 'Ross and Cromarty', value: 'Ross and Cromarty' },
                        { name: 'Roxburgh, Ettrick and Lauderdale', value: 'Roxburgh, Ettrick and Lauderdale' },
                        { name: 'Shetland Islands', value: 'Shetland Islands' },
                        { name: 'Stirling and Falkirk', value: 'Stirling and Falkirk' },
                        { name: 'Sutherland', value: 'Sutherland' },
                        { name: 'The Stewartry of Kirkcudbright', value: 'The Stewartry of Kirkcudbright' },
                        { name: 'Tweeddale', value: 'Tweeddale' },
                        { name: 'West Lothian', value: 'West Lothian' },
                        { name: 'Western Isles', value: 'Western Isles' },
                        { name: 'Wigtown', value: 'Wigtown' },
                    ]
                },
                {
                    name: 'Wales',
                    options: [
                        { name: 'Blaenau Gwent', value: 'Blaenau Gwent' },
                        { name: 'Bridgend', value: 'Bridgend' },
                        { name: 'Caerphilly', value: 'Caerphilly' },
                        { name: 'Cardiff', value: 'Cardiff' },
                        { name: 'Carmarthenshire', value: 'Carmarthenshire' },
                        { name: 'Ceredigion', value: 'Ceredigion' },
                        { name: 'Conwy', value: 'Conwy' },
                        { name: 'Denbighshire', value: 'Denbighshire' },
                        { name: 'Flintshire', value: 'Flintshire' },
                        { name: 'gwynedd', value: 'gwynedd' },
                        { name: 'Isle of Anglesey', value: 'Isle of Anglesey' },
                        { name: 'Merthyr Tydfil', value: 'Merthyr Tydfil' },
                        { name: 'Monmouthshire', value: 'Monmouthshire' },
                        { name: 'Neath Port Talbot', value: 'Neath Port Talbot' },
                        { name: 'Newport', value: 'Newport' },
                        { name: 'Pembrokeshire', value: 'Pembrokeshire' },
                        { name: 'Powys', value: 'Powys' },
                        { name: 'Rhondda Cynon Taf', value: 'Rhondda Cynon Taf' },
                        { name: 'Swansea', value: 'Swansea' },
                        { name: 'Torfaen', value: 'Torfaen' },
                        { name: 'Vale of Glamorgan', value: 'Vale of Glamorgan' },
                        { name: 'Wrexham', value: 'Wrexham' },
                    ]
                },
                {
                    name: 'Northern Ireland',
                    options: [
                        { name: 'Antrim', value: 'Antrim' },
                        { name: 'Ards', value: 'Ards' },
                        { name: 'Armagh', value: 'Armagh' },
                        { name: 'Ballymena', value: 'Ballymena' },
                        { name: 'Ballymoney', value: 'Ballymoney' },
                        { name: 'Banbridge', value: 'Banbridge' },
                        { name: 'Belfast', value: 'Belfast' },
                        { name: 'Carrickfergus', value: 'Carrickfergus' },
                        { name: 'Castlereagh', value: 'Castlereagh' },
                        { name: 'Coleraine', value: 'Coleraine' },
                        { name: 'Cookstown', value: 'Cookstown' },
                        { name: 'Craigavon', value: 'Craigavon' },
                        { name: 'Derry', value: 'Derry' },
                        { name: 'Down', value: 'Down' },
                        { name: 'Dungannon and South Tyrone', value: 'Dungannon and South Tyrone' },
                        { name: 'Fermanagh', value: 'Fermanagh' },
                        { name: 'Larne', value: 'Larne' },
                        { name: 'Limavady', value: 'Limavady' },
                        { name: 'Lisburn', value: 'Lisburn' },
                        { name: 'Magherafelt', value: 'Magherafelt' },
                        { name: 'Moyle', value: 'Moyle' },
                        { name: 'Newry and Mourne', value: 'Newry and Mourne' },
                        { name: 'Newtownabbey', value: 'Newtownabbey' },
                        { name: 'North Down', value: 'North Down' },
                        { name: 'Omagh', value: 'Omagh' },
                        { name: 'Strabane', value: 'Strabane' },
                    ]
                },
            ]
        }
    }
}
